import { EditableMediaTypes, EditableType } from "../enums/editables";

export function isImageType(type: string) {
    return type === EditableType.Image;
}

export default function isMediaType(type: string) {
    return EditableMediaTypes.includes(type as (typeof EditableMediaTypes)[number]);
}
